import axios from 'axios'
// import * as Utils from '../modules/Utils'
import * as Navigator from '../modules/Navigator'
import auth from '../auth/service'
import project from '../../project.config'

/**
 * update http.js, storage.js, signalRStart.js, config.js, project.config.js
 */
const API_POST_METHOD = 'POST'
const API_GET_METHOD = 'GET'
const API_PUT_METHOD = 'PUT'
const API_DELETE_METHOD = 'DELETE'
const API_BASE_URL = project.apiBaseUrl
const API_TIMEOUT = 180000
const FORM_CONTENT_TYPE = 'application/x-www-form-urlencoded'
const FILE_CONTENT_TYPE = 'multipart/form-data'
const XLSX_CONTENT_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
const PDF_CONTENT_TYPE = 'application/pdf'
const TEXT_CONTENT_TYPE = 'text/plain'
export const API_CLIENT_ID = 'ngAuthApp'
export const API_GRANT_REFRESH = 'refresh_token'
export const API_GRANT_PASSWORD = 'password'
export const API_CLIENT_SECRET = '1234@abcd'

const axiosInstance = axios.create()
const CancelToken = axios.CancelToken
let source = CancelToken.source()
axiosInstance.defaults.baseURL = API_BASE_URL
axiosInstance.defaults.timeout = API_TIMEOUT

// TODO: how to use the refresh token?
axiosInstance.interceptors.response.use(response => response, error => {
  // Do something with response error
  if (error.response.status === 401) {
    // cancel current requests
    source.cancel()
    // generate new cancel token
    source = CancelToken.source()
    auth.localLogout()
    Navigator.goToPage(Navigator.HOME_PAGE)
    // auth.loginCallback = () => {
    //   window.location.reload()
    // }
    // auth.renewToken()
  }
  return Promise.reject(error.response)
})

const makeRequest = (config, contentType) => {
  axiosInstance.defaults.headers.post['Content-Type'] = contentType || TEXT_CONTENT_TYPE
  if (auth.isAuthenticated()) {
    axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + auth.getAccessToken()
  }
  return axiosInstance(config).then((response) => response.data)
}

const withCancelToken = (config) => {
  return {
    ...config,
    cancelToken: source.token
  }
}

export function PUT (url, data) {
  const method = API_PUT_METHOD
  return makeRequest(withCancelToken({ url, method, data }))
}

export function POST (url, data, params) {
  const method = API_POST_METHOD
  return makeRequest(withCancelToken({ url, method, data, params }))
}

export function POSTFORM (url, data) {
  const method = API_POST_METHOD
  return makeRequest({ url, method, data }, FORM_CONTENT_TYPE)
}

export function POSTUPLOAD (url, data) {
  const method = API_POST_METHOD
  return makeRequest(withCancelToken({ url, method, data }), FILE_CONTENT_TYPE)
}

export function POSTEXPORT (url, data) {
  const method = API_POST_METHOD
  return makeRequest(withCancelToken({ url, method, data, responseType: 'blob' }), XLSX_CONTENT_TYPE)
}

export function POSTEXPORTPDF (url, data) {
  const method = API_POST_METHOD
  return makeRequest(withCancelToken({ url, method, data, responseType: 'blob' }), PDF_CONTENT_TYPE)
}

export function GET (url, params) {
  const method = API_GET_METHOD
  return makeRequest(withCancelToken({ url, method, params }))
}

export function DELETE (url, params, data) {
  const method = API_DELETE_METHOD
  return makeRequest(withCancelToken({ url, method, params, data }))
}



// WEBPACK FOOTER //
// ./src/api/http.js